import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: '首页',
			component: () => import('@/views/index/index'),
			meta: { title: '凌云数据' }
		},
		{
			path: '/m',
			name: '首页',
			component: () => import('@/views/index/mobile_index'),
			meta: { title: '凌云数据' }
		},
		// 
		{
			path: '/nft',
			name: 'NFT',
			component: () => import('@/views/nft/index'),
			meta: { title: 'NFT数藏平台' }
		},

		{
			path: '/nft_m',
			name: 'nft_m',
			component: () => import('@/views/nft/mobile_index'),
			meta: { title: 'NFT数字产品' }
		},
		{
			path: '/aboutus',
			name: '关于我们',
			component: () => import('@/views/aboutUs/index'),
			meta: { title: '凌云数据-关于我们' }
		},
		{
			path: '/mAboutus',
			name: '关于我们',
			component: () => import('@/views/aboutUs/mobile_index'),
			meta: { title: '凌云数据-关于我们' }
		},
		{
			path: '/intelligent',
			name: '扫码点餐',
			component: () => import('@/views/intelligent/index'),
			meta: { title: '凌云数据-扫码点餐' }
		},
		{
			path: '/mIntelligent',
			name: '扫码点餐',
			component: () => import('@/views/intelligent/mobile_index'),
			meta: { title: '凌云数据-扫码点餐' }
		},
		{
			path: '/mall',
			name: '电商商城',
			component: () => import('@/views/mall/index'),
			meta: { title: '凌云数据-电商商城' }
		},
		{
			path: '/mMall',
			name: '电商商城',
			component: () => import('@/views/mall/mobile_index'),
			meta: { title: '凌云数据-电商商城' }
		},
		{
			path: '/shortVideo',
			name: '短视频',
			component: () => import('@/views/shortVideo/index'),
			meta: { title: '凌云数据-短视频' }
		},
		{
			path: '/mShortVideo',
			name: '短视频',
			component: () => import('@/views/shortVideo/mobile_index'),
			meta: { title: '凌云数据-短视频' }
		},
		{
			path: '/liveMall',
			name: '新零售直播商城',
			component: () => import('@/views/liveMall/index'),
			meta: { title: '凌云数据-新零售直播商城' }
		},
		{
			path: '/mLiveMall',
			name: '新零售直播商城',
			component: () => import('@/views/liveMall/mobile_index'),
			meta: { title: '凌云数据-新零售直播商城' }
		},
		{
			path: '/knowledgePayment',
			name: '',
			component: () => import('@/views/knowledgePayment/index'),
			meta: { title: '知识付费' }
		},
		// {
		//   path: '/mDoukeyun',
		//   name: '',
		//   component: () => import('@/views/doukeyun/mobile_index'),
		//   meta: { title: ' 凌云数据短视频同城霸屏    短视频获客引流系统  矩阵营销  裂变霸屏神器  短视频流量变现  短视频如何引流' }
		// },
		{
			path: '/mProductCenter',
			name: '产品中心',
			component: () => import('@/views/productCenter/mobile_index'),
			meta: { title: '凌云数据-产品中心' }
		},
		{
			path: '/mCustomDevelopment',
			name: '定制开发',
			component: () => import('@/views/customDevelopment/mobile_index'),
			meta: { title: '凌云数据-定制开发' }
		},
		/* 刷脸支付子官网 */
		{
			path: '/pay',
			name: '首页',
			component: () => import('@/views/pay/index')
		},
		{
			path: '/pay/index',
			name: '首页',
			component: () => import('@/views/pay/index')
		},
		{
			path: '/pay/mobile_index',
			name: '首页',
			component: () => import('@/views/pay/mobile_index')
		},
		{
			path: '/pay/channel',
			name: '渠道合作',
			component: () => import('@/views/pay/channel/index')
		},
		{
			path: '/pay/mChannel',
			name: '渠道合作',
			component: () => import('@/views/pay/channel/mobile_index')
		},
		{
			path: '/pay/inquiry',
			name: '授权认证查询',
			component: () => import('@/views/pay/inquiry')
		},
		{
			path: '/pay/aboutus',
			name: '关于我们',
			component: () => import('@/views/pay/aboutUs/index')
		},
		{
			path: '/pay/mAboutus',
			name: '关于我们',
			component: () => import('@/views/pay/aboutUs/mobile_index')
		},
		{
			path: '/pay/product/aifacevip',
			name: 'AI刷脸会员',
			component: () => import('@/views/pay/product/aifacevip/index')
		},
		{
			path: '/pay/product/mAifacevip',
			name: 'AI刷脸会员',
			component: () => import('@/views/pay/product/aifacevip/mobile_index')
		},
		{
			path: '/pay/product/aifacepayment',
			name: 'AI刷脸支付',
			component: () => import('@/views/pay/product/aifacepayment/index')
		},
		{
			path: '/pay/product/mAifacepayment',
			name: 'AI刷脸支付',
			component: () => import('@/views/pay/product/aifacepayment/mobile_index')
		},
		{
			path: '/pay/product/qingting',
			name: '蜻蜓',
			component: () => import('@/views/pay/product/qingting/index')
		},
		{
			path: '/pay/product/mQingting',
			name: '蜻蜓',
			component: () => import('@/views/pay/product/qingting/mobile_index')
		},
		{
			path: '/pay/product/qingwa',
			name: '青蛙',
			component: () => import('@/views/pay/product/qingwa/index')
		},
		{
			path: '/pay/product/mQingwa',
			name: '青蛙',
			component: () => import('@/views/pay/product/qingwa/mobile_index')
		},
		{
			path: '/pay/product/cashierTerminal',
			name: '刷脸会员双屏式收银终端',
			component: () => import('@/views/pay/product/cashierTerminal/index')
		},
		{
			path: '/pay/product/mCashierTerminal',
			name: '刷脸会员双屏式收银终端',
			component: () => import('@/views/pay/product/cashierTerminal/mobile_index')
		},
		{
			path: '/pay/product/selfServiceTerminal',
			name: '刷脸支付自助收银终端',
			component: () => import('@/views/pay/product/selfServiceTerminal/index')
		},
		{
			path: '/pay/product/mSelfServiceTerminal',
			name: '刷脸支付自助收银终端',
			component: () => import('@/views/pay/product/selfServiceTerminal/mobile_index')
		},
		{
			path: '/superHousekeeper',
			name: '凌云数据-超级管家',
			component: () => import('@/views/superHousekeeper/index')
		},
		{
			path: '/mSuperHousekeeper',
			name: '凌云数据-超级管家',
			component: () => import('@/views/superHousekeeper/mobile_index')
		},
		{
			path: '/shortLink',
			name: '超级短链',
			component: () => import('@/views/shortLink/index')
		},
		{
			path: '/mShortLink',
			name: '超级短链',
			component: () => import('@/views/shortLink/mobile_index')
		},
		{
			path: '/rentMall',
			name: '租赁商城小程序',
			component: () => import('@/views/rentMall/index')
		},
		{
			path: '/mRentMall',
			name: '租赁商城小程序',
			component: () => import('@/views/rentMall/mobile_index')
		},

		/* 测试用 */
		// {
		//   path: '/test',
		//   name: '测试页面',
		//   component: () => import('@/views/test/index'),
		//   meta: { title: '测试页面' }
		// },
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js